import * as S from "./JoinTypeSelect.style";

interface JoinTypeSelectProps {
  children: React.ReactElement;
}

export const JoinTypeSelect = ({ children }: JoinTypeSelectProps) => {
  return <S.JoinTypeSelect>{children}</S.JoinTypeSelect>;
};
